import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faEye, faDownload, faFileExport, faFileImport, faCircleInfo, faRotate, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { StorageKeys } from 'src/app/share/enums/storage.enum';
import { StockService } from 'src/app/share/services/stock/stock.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';

@Component({
    selector: 'app-view-import-stock-list',
    templateUrl: './view-import-stock-list.component.html',
    styleUrls: ['./view-import-stock-list.component.scss'],
    standalone: false
})
export class ViewImportStockListComponent implements OnInit {

  stockOutData: any[]=[];
  formattedDate: any;
  filterPayMode:string = "";
  filters      :any={
    page:0
  }
  user            !: any;
  payMode         : string= "";
  companyData     : any[]=[];
  sheetList       : any[] =[];
  company         : string = "";
  endOfResults    : boolean = false;
  showListDetails : boolean = false;
  showImportList  : boolean = true;
  stockListDetails: any;
  importListDate  : any;
  errorMessage: any;
  loader: boolean = false;
  selectedFile: any;
  selectedFileName: string = '';
  selectedImportOption: string = '';
  @ViewChild('importConfirmationModal') importConfirmationModal!: TemplateRef<any>;


  constructor(
    private readonly stockService: StockService,
    private readonly storageService: StorageService,
    private readonly modalService: NgbModal,
  ) {

  }

  ngOnInit(){
    let selfDetailsData = this.storageService.getDataFromLocalStorage(
      StorageKeys.SELF_DETAILS
    );
    if (selfDetailsData) {
      this.user = selfDetailsData.name
    }
    this.getSheetList();
  }

  getSheetList() {
    this.loader = true;
    this.stockService.getSheetList(this.filters).subscribe({
      next: (res: any) => {
      this.loader = false;
      if (res?.data) {
        this.sheetList = [...this.sheetList, ...res.data];
        if (res.data.length === 0) {
          this.endOfResults = true;
        }
      } else {
        this.endOfResults = true;
      }
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    });
  }

  importSheet(event: any, file: HTMLInputElement) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      this.selectedFile = selectedFile;
      this.selectedFileName = selectedFile.name;
      this.selectedImportOption = '';
      file.value = '';
      this.modalService.open(this.importConfirmationModal, { centered: true, size: 'xl' });
    }
  }

  selectImportOption(option: string) {
    this.selectedImportOption = option;
  }

  confirmUpload(importType: string) {
    this.modalService.dismissAll();
    this.loader = true;
    this.stockService.uploadSheet(this.selectedFile, importType).subscribe({
      next:(res: any)=> {
        this.loader = false;
        this.filters.page = 0;
        this.endOfResults = false;
        this.sheetList = [];
        this.getSheetList();
      }, 
      error: (error: any)=> {
        this.errorMessage = error?.error?.error?.message;
        this.loader = false;
      }
    })
  }

  onScroll() {
    if (this.endOfResults || this.loader) {
      return;
    } else {
      this.filters.page++;
      this.getSheetList();
    }
  }

  showListDts(fileId: any, importDate?:any){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.loader = true;
    const fileID = fileId;
    this.importListDate = importDate;
    this.showListDetails = true;
    this.showImportList = false;
    this.stockService.getListDetails(fileID).subscribe({
      next: (res:any)=>{ 
      this.loader = false;
      this.stockListDetails = res.data;
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    });
  }

  goBack(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.showListDetails = false;
    this.showImportList = true;
  }

  back() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  refreshList() {
    if(this.loader) return;
    this.sheetList = [];
    this.endOfResults = false;
    this.filters.page = 0;
    this.getSheetList();
  }

  protected faDownload = faDownload;
  protected faFileExport = faFileExport;
  protected faEye = faEye;
  protected faFileImport = faFileImport;
  protected faCircleInfo = faCircleInfo;
  protected faRotate = faRotate;
  protected faTriangleExclamation = faTriangleExclamation;
}
